/* eslint-disable camelcase */
import { BiCalendar } from 'react-icons/bi';

import _ from 'lodash';
import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import { useEffect, useRef } from 'react';
import { useMediaQuery } from 'react-responsive';
import { Viewer } from 'src/components/cards';
import { APP_IMG, SHOW_COMMEMORATE } from 'src/constants';
import { IAds } from 'src/modules/ads';
import { DataContent, Related } from 'src/modules/cid/id';
import { getAffiliate } from 'src/utils/contents/get-affiliate';
import { getFeatureImage } from 'src/utils/contents/get-image';
import { DATALAYER_TYPE, sendDataLayerGlobal } from 'src/utils/datalayer/send-datalayer';
import { useDateUpdate } from 'src/utils/helper';
import styled from 'styled-components';
import { KEY_ADS_POSITION } from '../ads/dynamicAds';
import WidgetShareSticky from '../widgets/widget-share-sticky';
import WidgetSpeech from '../widgets/widget-speech';
// import CardH from '../cards/card-h';
// import ReactSticky from 'react-sticky-box';
const DynamicAds = dynamic(import('../ads/dynamicAds'));

// const CardV = dynamic(import('src/components/cards/card-v'));
const CardH = dynamic(import('src/components/cards/card-h'));
const WidgetBreadcrumb = dynamic(import('src/components/widgets/widget-breadcrumb'));
const WidgetSocialShare = dynamic(import('src/components/widgets/widget-social-share'));
const WidgetGallery = dynamic(import('src/components/widgets/widget-gallery'));

type Props = {
  article: DataContent;
  _article: DataContent;
  countView: any;
  countViewCheck: number;
  related: Related[];
  dataAffiliate: any[];
  ads?: IAds[];
  dataPopular?: any;
  childSticky?: any;
};

const ArticleDefault = ({ article, _article, countView, countViewCheck, related, dataAffiliate, ads, childSticky }: Props) => {
  const router: any = useRouter();
  // const progressRef = useRef<any>(null);
  const navigationRef = useRef<any>(null);

  const handleProgress = () => {
    const scroll_top = window?.scrollY;
    const all_sections = document?.querySelectorAll('.paragraph');
    // const number_items = all_sections.length;

    // const found_element: any = null;
    // const found_number: any = null;

    all_sections.forEach((item: any) => {
      const section_id = item?.getAttribute('id');
      item?.setAttribute('offset-top', item?.offsetTop);

      const nav_item = document?.querySelector(`li[data-section=${section_id}]`);
      const offset_top = item?.getAttribute('offset-top');

      if (scroll_top >= Number(offset_top)) {
        nav_item?.classList?.add('active');
        // found_element = item;
        // found_number = index + 1;
      } else {
        nav_item?.classList?.remove('active');
      }
    });

    // const progress_bar = progressRef.current;

    // if (found_element != null) {
    //   const found_section_id = found_element?.getAttribute('id');
    //   const found_nav_item = navigationRef?.current?.querySelector(`li[data-section=${found_section_id}]`);

    //   const found_nav_item_offset = parseInt(found_nav_item?.offsetLeft);
    //   const found_nav_item_width = found_nav_item.offsetWidth;
    //   const extra_space = 60;

    //   const item_offset = found_nav_item_offset + found_nav_item_width + extra_space;
    //   const window_width = window.innerWidth;
    //   const progress = 100 - (item_offset / window_width) * 100;

    //   if (found_number === number_items) {
    //     progress_bar.style.transform = 'translateX(0%)';
    //   } else {
    //     progress_bar.style.transform = `translateX(-${progress}%)`;
    //   }
    // } else {
    //   progress_bar.style.transform = 'translateX(-100%)';
    // }
  };

  useEffect(() => {
    document.addEventListener('scroll', handleProgress);
    return () => document.removeEventListener('scroll', handleProgress);
  }, []);

  // handleCommemorate
  function getScrollTop() {
    if (typeof window.pageYOffset !== 'undefined') {
      // Most browsers
      return window.pageYOffset;
    }

    const d = document.documentElement;
    if (typeof d.clientHeight !== 'undefined') {
      // IE in standards mode
      return d.scrollTop;
    }

    // IE in quirks mode
    return document.body.scrollTop;
  }
  const isMb = useMediaQuery({ query: '(max-width: 768px)' });
  useEffect(() => {
    if (isMb) {
      window.onscroll = function () {
        const box = document.getElementById('widget-group-js');
        if (!_.isEmpty(box)) {
          const scroll = getScrollTop();
          if (scroll <= 0) {
            box!.style.top = '150px';
          } else {
            box!.style.top = 150 + scroll + 2 + 'px';
          }
        }
      };
    }
  }, []);
  // handleCommemorate
  // console.log('_article :', _article);
  return (
    <ArticleWrapper className='mt-20'>
      <div className='container navigation js--navigation' ref={navigationRef}>
        <ul className={`${!_article?.content_III ? '' : _article?.content_II ? '--two' : '--one'}`}>
          <li data-section='paragraph-1' className={'disable '}>
            <a href='#paragraph-1'></a>
          </li>
          {_article?.content_II && (
            <li data-section='paragraph-2' className='disable'>
              <a href='#paragraph-2'></a>
            </li>
          )}
          {_article?.content_III && (
            <li data-section='paragraph-3' className='disable'>
              <a href='#paragraph-3'></a>
            </li>
          )}
        </ul>
      </div>
      <div className='container' id='section-2'>
        <div className='row'>
          <div className='article-area col-12 col-md-12'>
            {/* ------------------------------- BREADCRUMB ------------------------------- */}
            <BreadcrumbWrapper className='breadcrumb-wrapper'>
              <WidgetBreadcrumb data={_article} />
            </BreadcrumbWrapper>
            {/* ----------------------------------- CONTENTS : HEADER ---------------------------------- */}
            <div className='post-info'>
              {article?.published_at && (
                <p className='date-time'>
                  <BiCalendar />
                  <span> {useDateUpdate(article?.published_at, true)} </span>
                </p>
              )}
              <div className='meta'>{countView >= countViewCheck && <Viewer data={countView} />}</div>
            </div>
            <div className='title-content'>
              <h1 className='category'>{_article?.title}</h1>
            </div>
            <div className='footer-feature'>
              <WidgetSocialShare
                articleLink={article?.link}
                // !DATALAYER
                eventDataLayer={{
                  type: DATALAYER_TYPE.TRACK_POSITION,
                  router: router?.pathname,
                  section: 'share',
                  position: 'after:หัวข้อข่าว'
                }}
              />
              <div className='byline-wrapper'>
                {article.bylineList &&
                  article?.bylineList.map((item: any, index: number) => (
                    <a key={index} href={`/bylines/${encodeURIComponent(item.p_name)}`} rel='noreferrer noopener nofollow' className='by-line'>
                      <p>
                        {item.p_name}
                        {article?.bylineList && index !== Number(article?.bylineList.length) - 1 ? ',' : ''}
                      </p>
                    </a>
                  ))}
              </div>
            </div>
            <div className='content-feature'>{getFeatureImage(_article)}</div>
            {<>{childSticky}</>}

            {/* Ads-PPN BILLBOARD */}
            {!_.isEmpty(ads) && <DynamicAds position={KEY_ADS_POSITION.BILLBOARD} data={ads} />}

            {/* ----------------------------------- CONTENTS : ARTICLE ---------------------------------- */}
            <div id='paragraph' className='contents'>
              {!_.isEmpty(_article?.key_point) ? (
                <div className='keypoint-wrapper'>
                  <HeadSeo
                    dangerouslySetInnerHTML={{
                      __html: `${article?.blurb || ''}`
                    }}
                  />
                  <div className='keypoint-header'>
                    <p>KEY</p>
                    <p>POINTS</p>
                  </div>
                  <div
                    className='keypoint-lists'
                    dangerouslySetInnerHTML={{
                      __html: _article.key_point ?? ''
                    }}
                  />
                </div>
              ) : (
                _article?.blurb && (
                  /* ----------------------------------- CONTENTS : BLURB ---------------------------------- */
                  <h2 className='content-blurb'>{_article.blurb}</h2>
                )
              )}

              {/* ------------------------- CONTENTS I : INARTICLE 1 ------------------------- */}
              {_article?.content_I && (
                <>
                  <div id='paragraph-1' className='paragraph'>
                    <div
                      className='content-detail'
                      dangerouslySetInnerHTML={{
                        __html: _article?.content_I
                      }}
                    />
                    {_article?.gallery && (
                      <WidgetGallery
                        data={_article}
                        eventDataLayer={{
                          type: DATALAYER_TYPE.TRACK_POSITION,
                          router: router?.pathname,
                          section: 'widget-gallery',
                          position: 'ใต้:paragraph-1'
                        }}
                      />
                    )}
                    {_article?.is_show_ads && getAffiliate(1, dataAffiliate)}
                    {/* <!-- /223513049/adopthailand/thepeople_r_content_t_728x90_336x280 --> */}
                    {/* <div id='div-apt-ad-LTBWhLlDur' /> */}
                    {/* Ads-PPN INARTICLE-1 */}
                    {!_.isEmpty(ads) && <DynamicAds position={KEY_ADS_POSITION.INARTICLE_1} data={ads} />}
                  </div>
                </>
              )}
              {/* ------------------------- CONTENTS II and ADS : INARTICLE 2 ------------------------ */}
              {_article?.content_II && (
                <>
                  <div id='paragraph-2' className='paragraph'>
                    <div
                      className='content-detail'
                      dangerouslySetInnerHTML={{
                        __html: _article?.content_II
                      }}
                    />
                    {_article?.is_show_ads && getAffiliate(2, dataAffiliate)}
                    {/* <!-- /223513049/adopthailand/thepeople_r_content_m_728x90_336x280 --> */}
                    {/* <div id='div-apt-ad-wv32mDfCrx' /> */}
                    {/* Ads-PPN INARTICLE-2 */}
                    {!_.isEmpty(ads) && <DynamicAds position={KEY_ADS_POSITION.INARTICLE_2} data={ads} />}
                  </div>
                </>
              )}

              {/* ---------------------------- relate news: desktop -------------------------- */}
              {!_.isEmpty(related) && (
                <div className='widget-content related-news-desktop'>
                  <div className='widget-content-title'>
                    <h3 className='related-news'>เนื้อหาที่เกี่ยวข้อง</h3>
                  </div>
                  <div className='block-content'>
                    <ul className='block-list'>
                      {related.slice(0, 3).map((item, index) => (
                        <li key={index}>
                          <CardH
                            data={item}
                            no={index}
                            external={false}
                            showImage={true}
                            showTitle={true}
                            showBlurb={false}
                            showByline={false}
                            showTime={true}
                            showCountview={true}
                            //! DATALAYER
                            eventDataLayer={{
                              type: DATALAYER_TYPE.TRACK_POSITION,
                              router: router?.pathname,
                              section: 'เนื้อหาที่เกี่ยวข้อง',
                              position: 'ใต้:paragraph-2',
                              data: {
                                block: '1',
                                title: item?.title,
                                heading: 'เนื้อหาที่เกี่ยวข้อง',
                                index: index + 1
                              }
                            }}
                          />
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              )}

              {/* -------------------------- CONTENTS III and ADS : INARTICLE 3 ----------------------- */}
              {_article?.content_III && (
                <>
                  <div id='paragraph-3' className='paragraph'>
                    <div
                      className='content-detail'
                      dangerouslySetInnerHTML={{
                        __html: _article?.content_III
                      }}
                    />
                    {_article?.is_show_ads && getAffiliate(3, dataAffiliate)}
                    {/* Ads-PPN INARTICLE-3 */}
                    {!_.isEmpty(ads) && <DynamicAds position={KEY_ADS_POSITION.INARTICLE_3} data={ads} />}
                  </div>
                </>
              )}
              {article?.bylineList && (
                <div className='row'>
                  {article?.bylineList.map((item, index) => (
                    <div className='byline col-12 col-md-6' key={index}>
                      <div className='byline-block'>
                        <a href={`/bylines/${item?.p_name}`}>
                          {!_.isEmpty(item?.image) ? (
                            <img loading='lazy' src={`${APP_IMG}${item?.image}`} alt='byline' className='img-byline' width='80' height='80' />
                          ) : (
                            <img loading='lazy' src={`${APP_IMG}/static/img-byline.png`} alt='byline' className='img-byline' width='80' height='80' />
                          )}
                        </a>
                        <div className='byline-content'>
                          <a href={`/bylines/${item?.p_name}`}>
                            <p className='byline-title'> {item?.p_name}</p>
                          </a>
                          {item?.description && (
                            <div
                              className='byline-desc'
                              dangerouslySetInnerHTML={{
                                __html: item?.description
                              }}
                            />
                          )}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}
              <WidgetSocialShare
                articleLink={article?.link}
                // !DATALAYER
                eventDataLayer={{
                  type: DATALAYER_TYPE.TRACK_POSITION,
                  router: router?.pathname,
                  section: 'share',
                  position: 'after:paragraph-3'
                }}
              />
              {/* --------------------------- ADS : Native (Infinities) ----------------------------------- */}
              {_article.is_show_ads && <div id='section-ads'>{/* <div id='ADOP_V_3vsZsppzdJ' style={{ height: 0 }}></div> */}</div>}

              {/* ------------------------------ READ_COMPLETE ------------------------ */}
              <div id='read-complete' className='content-tags'>
                <hr />
                {!_.isEmpty(_article?.tags) && <span className='heading-tag'>แท็กที่เกี่ยวข้อง</span>}
                <div className='scroll-tag'>
                  {!_.isEmpty(_article?.tags) &&
                    _article.tags.map((item, index) => (
                      <a
                        key={index}
                        title={item}
                        href={`/tags/${item}`}
                        //! DATALAYER
                        onClick={() =>
                          sendDataLayerGlobal({
                            type: DATALAYER_TYPE.TRACK_POSITION,
                            router: router?.pathname,
                            section: 'แท็กที่เกี่ยวข้อง',
                            position: 'after:widget-share',
                            data: {
                              title: item,
                              heading: item,
                              index: index + 1
                            }
                          })
                        }
                      >
                        {item}
                      </a>
                    ))}
                </div>
                <hr />
              </div>
            </div>
          </div>
        </div>
      </div>

      {!_.isEmpty(ads) && <DynamicAds position={KEY_ADS_POSITION.POSTARTICLE} data={ads} />}
      {/* ----------------------------------- CONTENTS : End ---------------------------------- */}
    </ArticleWrapper>
  );
};
const HeadSeo = styled.h2`
  position: absolute;
  visibility: hidden;
  overflow: hidden;
`;
const BreadcrumbWrapper = styled.div``;
const ArticleWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  .footer-feature {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    a.by-line {
      cursor: pointer;
      color: #ed1a3b;
    }
  }
  .byline-wrapper {
    display: flex;
    flex-wrap: wrap;
    @media (max-width: 767px) {
      .by-line {
        width: 100%;
        text-align: end;
      }
    }
  }
  .contents {
    position: relative;
    width: 100%;
    margin: 0 auto;
    padding: 0;
    max-width: 800px;
  }
  &.mt-20 {
    margin-top: 20px;
    @media (max-width: 480px) {
      margin-top: 10px;
    }
  }
  .article-area {
    /* margin: 30px 0; */
    width: 100%;
    .content-blurb {
      margin-bottom: 30px;
      font-size: 24px;
      font-weight: 400;
      line-height: 1.4;
      @media (max-width: 480px) {
        font-size: 26px;
      }
    }
    .content-detail {
      * {
        font-family: 'Sarabun', sans-serif !important;
      }
      overflow: hidden;
      margin-bottom: 1rem;
      font-size: 18px;
      @media (max-width: 768px) {
        font-size: 16px;
      }
      line-height: 2;
      picture {
        display: block;
        max-width: 80%;
        margin: 0px auto;
        width: 100%;
        @media (max-width: 768px) {
          max-width: 100%;
        }
      }
      ul,
      ol,
      * {
        li {
          margin-left: 1.5rem;
        }
      }
    }
    .post-info {
      display: flex;
      color: #ed1a3b;
      padding: 5px 0;
      .date-time {
        svg {
          margin-right: 5px;
        }
        display: flex;
        align-items: center;
        @media (max-width: 480px) {
          font-size: 14px;
        }
      }
      .meta {
        margin-left: 5px;
        .pageview {
          display: flex;
          justify-content: center;
          align-items: center;
        }
        svg {
          margin-right: 5px;
          vertical-align: middle;
          @media (max-width: 480px) {
            font-size: 14px;
          }
        }
      }
    }
    .title-content {
      @media (max-width: 480px) {
        margin: 15px 0;
      }
      h1 {
        line-height: 1.4;
        font-size: 40px;
        font-weight: 400;
        margin-bottom: 15px;
        @media (max-width: 768px) {
          font-size: 32px;
        }
        @media (max-width: 480px) {
          font-size: 26px;
        }
      }
    }
    .content-tags {
      font-size: 16px;

      hr {
        margin: 30px 0;
        border: 1px solid #42424214;
      }
      .heading-tag {
        border-radius: 2px;
        padding: 4px 10px;
        border: 1px solid rgb(237, 26, 59);
        background-color: rgb(237, 26, 59);
        color: rgb(255, 255, 255);
        margin-right: 8px;
        font-weight: 600;
        margin-bottom: 15px;
      }
      .scroll-tag {
        min-height: 100px;
        overflow-y: scroll;
        margin-top: 25px;
        &::-webkit-scrollbar {
          width: 3px;
          border-radius: 10px;
          background-color: #fff;
        }

        &::-webkit-scrollbar-track {
          border-radius: 10px;
          background-color: #fff;
        }

        &::-webkit-scrollbar-thumb {
          border-radius: 10px;
          background-color: rgb(237, 26, 59);
        }
      }
      a {
        display: inline-flex;
        border: 1px solid rgb(0, 0, 0);
        border-radius: 2px;
        padding: 4px 8px;
        color: rgb(68, 68, 68);
        margin: 5px 5px 0px 0px;
        &:hover {
          color: rgb(255, 255, 255);
          background-color: rgb(237, 26, 59);
          border: 1px solid rgb(237, 26, 59);
        }
      }
    }

    .content-feature {
      margin: 30px 0 0 0;
      .embed-responsive {
        iframe {
          display: block;
          position: relative !important;
          margin: auto !important;
          width: 100% !important;
          height: 675px;

          @media (max-width: 540px) {
            height: 210px;
          }
        }
      }
    }
  }
  .keypoint-wrapper {
    display: flex;
    border-top: 7px solid #ed1a3b;
    padding: 30px 0;
    margin-top: 10px;
    border-bottom: 1px dashed #ed1a3b;

    .keypoint-header {
      margin-top: 8px;
      p {
        color: #ed1a3b;
        font-size: 25px;
        font-weight: bolder;
        letter-spacing: 0.4px;
        line-height: 1.05;
        text-transform: uppercase;
      }
    }
    .keypoint-lists {
      overflow: hidden;
      display: flex;
      align-items: center;
    }
    ul {
      padding-left: 30px;
      @media (max-width: 767px) {
        padding-left: 15px;
        padding-top: 15px;
      }
      li {
        display: flex;
        align-items: flex-start;

        ::marker {
          font-size: 24px;
          line-height: 0;
          color: #ed1a3b;
        }
        list-style-type: disc;
        display: list-item;
        margin-left: 1.5rem;
        line-height: 1.65;
        font-size: 20px;
        a {
          letter-spacing: 0.2px;
          font-display: swap;
        }
      }
    }
    @media (max-width: 767px) {
      display: block;

      padding: 20px 0;
      margin-bottom: 30px;
      .keypoint-header {
        display: flex;
        p {
          font-size: 22px;
        }
        margin-top: 0px;
      }
      ul {
        li {
          font-size: 16px;
        }
      }
    }
  }
  .byline {
    margin: 0px 0 30px 0;
    .byline-block {
      padding: 10px;
      display: flex;
      align-items: center;
      width: 100%;
      border-radius: 30px;
      background-color: #fff;
      box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.1);
    }
    .img-byline {
      width: 80px;
      aspect-ratio: 1/1;
      /* max-width: 100%; */
      border-radius: 100%;
      object-fit: cover;
      object-position: center;
    }
    .byline-content {
      margin-left: 15px;
      .byline-title {
        font-size: 16px;
      }
      .byline-desc {
        margin-top: 12px;
        p {
          font-size: 14px;
          &:not(:last-child) {
            margin-bottom: 5px;
          }
        }
      }
    }
  }
  .title-right {
    padding-left: 6px;
    text-transform: capitalize;
    margin: 5px 0;
    @media (max-width: 768px) {
      margin: 20px 0 0 0;
    }
    h2 {
      font-size: 32px;
      font-weight: 400;
      @media (max-width: 768px) {
        font-size: 26px;
      }
      strong {
        color: #ed1a3b;
      }
    }
  }
  .most-view-desktop {
    display: block;
    .side-right {
      overflow-y: scroll;
      height: 300px;
      &::-webkit-scrollbar {
        width: 4px;
        background-color: #f5f5f5;
      }

      &::-webkit-scrollbar-track {
        background-color: rgba(247, 247, 247, 0.9);
      }

      &::-webkit-scrollbar-thumb {
        border-radius: 50px;
        background-color: rgb(220 21 53);
      }
    }
  }
  /* related */
  .related {
    margin-top: 24px;
    .related-carousels {
      display: block !important;
      width: 100% !important;
      max-width: 100%;
      margin: auto;
    }
    h2 {
      font-size: 32px;
      font-weight: 500;
      padding: 0 10px;
      margin-bottom: 12px;
      text-transform: capitalize;
      @media (max-width: 768px) {
        font-size: 26px;
      }
    }
    .slick-slider {
      margin: 0 -10px;
    }
    .card-item {
      padding: 0 10px;

      img {
        margin-top: unset;
      }
    }
  }

  /* cookie sticky */
  #cookie {
    position: sticky;
    bottom: 0;
  }
`;

export default ArticleDefault;
